import Layout from '../modules/Layout';
import Article from '../modules/Article';
import { CustomNextPage } from '../lib/types';
import { getQueryString } from '../lib/utils';
import { articlePageQuery, articlePageQueryVariables } from '../core-types';
import { ARTICLE_PAGE_QUERY } from '../lib/core/ArticlePageQuery';
import { bootstrap } from '../lib/bootstrap';
import { useQuery } from '@apollo/client';

export const ArticlePage: CustomNextPage<{
  statusCode?: number;
}> = props => {
  const { url, statusCode } = props;
  const slug = getQueryString(url.query.slug);
  if (!slug) {
    throw new Error('Slug not provided');
  }
  const { loading, data } = useQuery<
    articlePageQuery,
    articlePageQueryVariables
  >(ARTICLE_PAGE_QUERY, { variables: { slug } });
  const title = data && data.articlePage && data.articlePage.title;
  return (
    <Layout
      statusCode={statusCode}
      title={title}
      url={url}
      loading={loading}
      render={({ appContent }) => {
        if (!data || !data.articlePage) {
          const err = new Error(`Page not found, slug ${url.query.slug}`);
          err.code = 'ENOENT';
          throw err;
        }
        return <Article data={data.articlePage} appContent={appContent} />;
      }}
    />
  );
};

ArticlePage.getInitialProps = async ctx => {
  const slug = getQueryString(ctx.query.slug);
  if (!slug) {
    throw new Error('Slug not provided');
  }
  const articlePageQueryResult = await ctx.apolloClient.query<
    articlePageQuery,
    articlePageQueryVariables
  >({
    query: ARTICLE_PAGE_QUERY,
    variables: { slug }
  });

  let statusCode;
  if (!articlePageQueryResult.data?.articlePage) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return { statusCode };
};

export default bootstrap(ArticlePage);
